export enum RESERVED_KEYS {
  ENVIRONMENT = 'ENVIRONMENT',
  BRAND_MAP = 'BRAND_MAP',
  DEBUG_SETTINGS = 'DEBUG_SETTINGS',
  ANALYTICS_SCHEMAS = 'ANALYTICS_SCHEMAS',
  REDUX_PERSIST = 'REDUX_PERSIST',
}

export const OVERRIDE_CONFIG_KEY = 'override-config'

export const MAX_USER_AGE = 120

export enum ANDROID_API_VERSION {
  GINGERBREAD = 9, // Unsupported since 09/2015
  HONEYCOMB = 11, // Unsupported since 02/2012
  ICE_CREAM_SANDWICH = 14, // Unsupported since 01/2017
  JELLY_BEAN = 16, // Unsupported since 01/2018
  KITKAT = 19, // Unsupported since 11/2018
  LOLLIPOP = 21, // Unsupported since 03/2021
  MARSHMALLOW = 23, // Unsupported since 09/2021
  NOUGAT = 24, // Unsupported since 09/2021
  OREO = 26, // Unsupported since 08/2021
  PIE = 28, // Unsupported since 11/2021
  ANDROID_10 = 29, // Unsupported since 01/2022
  ANDROID_11 = 30, // Unsupported since 04/2023
  ANDROID_12 = 31, // Unsupported since 03/2023
  ANDROID_12L = 32, // Unsupported since 12/2022
  ANDROID_13 = 33, // Unsupported since 04/2024
  ANDROID_14 = 34, // Currently supported
}
